import { render, staticRenderFns } from "./ProductionUnitMeasurementActivityView.vue?vue&type=template&id=257134cc"
import script from "./ProductionUnitMeasurementActivityView.vue?vue&type=script&lang=js"
export * from "./ProductionUnitMeasurementActivityView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports